import { queryOptions } from "@tanstack/react-query";
import type { getQuotationListForm, QuotationCopyForm } from "../dtos/request/quotation.request";
import { getQuotationCopyList, getQuotationDefault, getQuotationDetail, getQuotationList, getQuotationRecent } from "../v1/quotation.service";


export const useQuotationList = (form: getQuotationListForm) =>
  queryOptions({
    queryKey: ["quotation-list", form.page, form.category, form.size],
    queryFn: () => getQuotationList(form),
    retry: 1,
  });

export const useQuotationDefault = (storeId?: string | number) =>
  queryOptions({
    queryKey: ["quotation-default", storeId],
    queryFn: () => getQuotationDefault(storeId),
    retry: 1,
  });

export const useQuotationRecent = (id: string) =>
  queryOptions({
    queryKey: ["quotation-recent", id],
    queryFn: () => getQuotationRecent(id),
    retry: 1,
  });

export const useQuotationDetail = (id: string) =>
  queryOptions({
    queryKey: ["quotation-detail", id],
    queryFn: () => getQuotationDetail(id),
    retry: 1,
  });

export const useQuotationCopyList = (form: QuotationCopyForm) => queryOptions({
  queryKey: ["quotation-copy-list", form],
  queryFn: () => getQuotationCopyList(form),
  retry: 1
})
